import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FlexBox } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';
import { useCallback } from 'react';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
import { ConversationsAgentFilter } from './components/agent/conversationsAgentFilter';
import { ConversationsChannelFilter } from './components/channel/conversationsChannelFilter';
import { ConversationsContactFilter } from './components/contact/conversationsContactFilter';
import { ConversationsDirectionFilter } from './components/direction/conversationsDirectionFilter';
import { ConversationsQueueFilter } from './components/queue/conversationsQueueFilter';
import { ConversationsStatusFilter } from './components/status/conversationsStatusFilter';
/** Represents the conversations filters toolbar component. */
export const ConversationsFiltersToolbar = ({ className, }) => {
    const { unsetParams } = useAppSearchParams('/conversations');
    /** Handles clearing all filters. */
    const handleClearAll = useCallback(() => unsetParams([
        'agent',
        'assigned',
        'channel',
        'direction',
        'limit',
        'offset',
        'queue',
        'requester',
        'status',
    ]), [unsetParams]);
    return (_jsxs(FlexBox, Object.assign({ className: className, flexWrap: "wrap", justifyContent: "flex-end", gap: sizes.spacer[200] }, { children: [_jsx(ConversationsDirectionFilter, {}), _jsx(ConversationsAgentFilter, {}), _jsx(ConversationsContactFilter, {}), _jsx(ConversationsChannelFilter, {}), _jsx(ConversationsQueueFilter, {}), _jsx(ConversationsStatusFilter, {}), _jsx(Button, Object.assign({ variant: "secondary", onClick: handleClearAll }, { children: "Clear all" }))] })));
};
